const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-8 mt-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-4">
          <p className="text-gray-600 dark:text-gray-200 mb-2">
            Made by The <span className="text-brand-primary font-semibold">EightyThree</span><span className="font-semibold">Labs</span> Team
          </p>
        </div>
        
        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-4 text-sm">
          <a 
            href="https://eightythreelabs.com/about.html" 
            className="text-gray-600 dark:text-gray-200 hover:text-brand-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            About Us
          </a>
          <a 
            href="https://eightythreelabs.com/privacy-policy.html" 
            className="text-gray-600 dark:text-gray-200 hover:text-brand-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a 
            href="https://eightythreelabs.com/terms-of-service.html" 
            className="text-gray-600 dark:text-gray-200 hover:text-brand-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          <a 
            href="https://eightythreelabs.com/cookie-policy.html" 
            className="text-gray-600 dark:text-gray-200 hover:text-brand-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
        </div>
        
        <div className="text-center text-xs text-gray-500 dark:text-gray-300">
          © {new Date().getFullYear()} EightyThreeLabs. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;